import React, { Component } from "react";
import { observer } from "mobx-react";
import { select_addr_fornaver_detail_check_pos } from "../../../http/addrConn";
import { fn_search_address_deail_box_show } from "../../../function/FnBodyLayer";



@observer
class AddressSearchForPosViewItem extends Component {
    constructor(props) {
        super(props);
        this.addressScrollSet = props.addressScrollSet.bind(this);
    }

    render() {
        const { rootStore, addr } = this.props;

        return (

            <li className={addr.click_obj ? "on" : ""}>
                <button
                    onClick={event => {
                        //naver
                        if (rootStore.addressSearchStore.getAddrApiName.api === "naver") {
                            select_addr_fornaver_detail_check_pos(rootStore, "list", addr.address, addr.roadAddress).then(r => {
                                rootStore.addressSearchStore.setSearchAddrClickObj(addr.address, addr.id);   // 선택한 주소 on표시
                                fn_search_address_deail_box_show(rootStore, true);
                            })
                        } else {
                            document.getElementById("addAdressPos").value = addr.place_name;
                            rootStore.addressSearchStore.setSearchAddrClickObj(addr.address, addr.id);   // 선택한 주소 on표시
                            rootStore.addressSearchStore.setKakaoMap(addr.y, addr.x)
                            fn_search_address_deail_box_show(rootStore, true);
                            select_addr_fornaver_detail_check_pos(rootStore, "list", addr.address, addr.roadAddress).then(r => {
                            })
                        }

                        rootStore.addressSearchStore.setClickedPosAddress(addr.address);
                        //목록 스크롤 위치 다시 지정.(마우스휠 이동할 경우 대응)
                        let addressArea = document.getElementById("addressListElement")
                        this.addressScrollSet(addressArea.scrollTop)
                    }}
                >
                    <span className="address">{addr.address}</span>
                    <span className="road_name">(도로명) {addr.roadAddress}</span>
                </button>
            </li>
        );
    }
}

export default AddressSearchForPosViewItem;